import React, { Fragment, useEffect } from "react";
import Header from "../../components/Header/Header";
import Scrollbar from "../../components/scrollbar/scrollbar";
import Footer from "../../components/footer/Footer";
import GdPageHero from "./components/GdPageHero";
import GdIntroSection from "./components/GdIntroSection";
import GdBusinessModelSection from "./components/GdBusinessModelSection";
import GdHowItWorksSection from "./components/GdHowItWorksSection";
import GdPanelsSection from "./components/GdPanelsSection";
import GdCustomerAppSection from "./components/GdCustomerAppSection";
import GdDeliveryBoySection from "./components/GdDeliveryBoySection";
import GdBenefitsSection from "./components/GdBenefitsSection";
import WdevTestimonials from "../WebDevelopmentPage/components/WdevTestimonials";
import GdCtaBanner from "./components/GdCtaBanner";
import "../WebDevelopmentPage/web-development.css";
import "./grocery-delivery.css";

const GroceryDeliveryPage: React.FC = () => {
  useEffect(() => {
    document.title =
      "Grocery Delivery App | WebTech Software Solutions Bangalore";
    const description =
      "WebTech builds on-demand grocery delivery apps in Bangalore — Instacart & Amazon Fresh style solutions with customer, vendor, delivery boy, and admin panels.";
    let meta = document.querySelector<HTMLMetaElement>('meta[name="description"]');
    if (!meta) {
      meta = document.createElement("meta");
      meta.name = "description";
      document.head.appendChild(meta);
    }
    meta.content = description;
  }, []);

  return (
    <Fragment>
      <div className="wdev-page inner-page gd-page">
        <div className="body_wrap o-clip">
          <Header />
          <main>
            <GdPageHero />
            <GdIntroSection />
            <GdBusinessModelSection />
            <GdHowItWorksSection />
            <GdPanelsSection />
            <GdCustomerAppSection />
            <GdDeliveryBoySection />
            <GdBenefitsSection />
            <WdevTestimonials />
            <GdCtaBanner />
          </main>
          <Footer />
          <Scrollbar />
        </div>
      </div>
    </Fragment>
  );
};

export default GroceryDeliveryPage;
